import {
    PRICE_FETCH,
    PRICE_SET_ITEM,
    PRICE_SET_ACCESSORIES,
} from '../constants';

export const price = (
    state = {
        price: '',
        oldPrice: '',
        priceValue: 0.0,
        currency: '',
        isCampaignPrice: false,
        isTierPrice: false,
        itemId: '',
        accessories: []
    },
    action
) => {
    switch (action.type) {
        case PRICE_SET_ITEM:
        case PRICE_SET_ACCESSORIES:
        case PRICE_FETCH:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};